<template>
  <a-config-provider
    :theme="{
      token: {
        fontFamily:
          'Helvetica Neue, Helvetica, Hiragino Sans, Hiragino Kaku Gothic ProN, Arial, Yu Gothic, Meiryo, sans-serif'
      }
    }"
  >
  </a-config-provider>
  <a-layout
    :style="{ minHeight: '100vh' }"
    :class="{ 'admin-layout': isAdmin, 'user-layout': !isAdmin }"
  >
    <Header :showSiderToggle="showSiderToggle" />
    <a-layout has-sider>
      <transition name="slide-fade">
        <a-layout-sider
          v-if="!siderCollapsed"
          :trigger="null"
          width="280"
          theme="light"
          class="pt-[112px] md:pt-[88px]"
        >
          <Sider />
          <!-- Telephone enquiries card -->
          <div
            v-if="isDischarger"
            class="p-2 bg-white border-4 border-double border-[#0283E6] rounded-3xl mx-4 mb-4 mt-5 text-center"
          >
            <h3 class="text-[#0283E6] font-bold">{{ $t('contact_us_by_phone') }}</h3>
            <div class="text-[#0283E6] text-[16px] font-semibold mb-2">
              <img src="@/assets/images/phone.jpg" alt="phone" class="w-6 inline-block" />
              0 3 - 6 8 2 3 - 8 5 0 5
              <div class="mt-2">info@canopus-inc.com</div>
            </div>

            <div class="text-[#0283E6] text-sm font-bold">
              {{ $t('reception_hours_monsat') }} 10:00～17:00
            </div>
          </div>
        </a-layout-sider>
      </transition>

      <a-layout-content class="overflow-hidden">
        <div class="card-container">
          <Error v-if="state.isError" />
          <router-view v-else v-slot="{ Component, route }" :key="$route.fullPath">
            <Breadcrumb :route="route" />
            <keep-alive :include="keepAliveIncludeItems">
              <component :is="Component" :key="route.fullPath" />
            </keep-alive>
          </router-view>
        </div>
      </a-layout-content>
      <!-- <Chat /> -->
    </a-layout>
  </a-layout>
</template>

<script setup lang="ts">
import { computed, onMounted, onErrorCaptured, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useLayoutStore } from '@/stores';
import { PhoneOutlined } from '@ant-design/icons-vue';
import Chat from '@/components/Chat.vue';
import logo from '@/assets/images/logo.svg';
import Header from './Header.vue';
import Sider from './Sider.vue';
import Tabbar from './Tabbar.vue';
import Error from './Error.vue';
import Breadcrumb from './Breadcrumb.vue';
import { useAuthStore } from '@/stores';

const authStore = useAuthStore();
const { isAdmin, isDischarger, isTransporter } = storeToRefs(authStore);

const state = reactive({
  isError: false
});
const router = useRouter();
const layoutStore = useLayoutStore();
const keepAliveIncludeItems = computed(() => layoutStore.tabbarItems.map((val) => val.path));
const { siderCollapsed } = storeToRefs(layoutStore);
const sidebarToggleWidth = 992;
const showSiderToggle = ref(document.body.clientWidth < sidebarToggleWidth);

onMounted(() => {
  window.addEventListener('resize', () => {
    const screenWidth = document.body.clientWidth;
    showSiderToggle.value = screenWidth < sidebarToggleWidth;
    if (screenWidth < sidebarToggleWidth) {
      layoutStore.$patch({ siderCollapsed: true });
    } else {
      layoutStore.$patch({ siderCollapsed: false });
    }
  });
});

router.beforeResolve(() => {
  state.isError = false;
});

onErrorCaptured((err) => {
  state.isError = true;
  console.error('--> onErrorCaptured.err', err);
  return false;
});
</script>

<style lang="scss">
.user-layout .ant-layout-sider-light {
  background: #0283e6 !important;
}

.user-layout .ant-menu-light {
  color: white !important;
  background: #0283e6 !important;
}

.admin-layout .ant-layout-sider-light {
  background: #f46666 !important;
}

.admin-layout .ant-menu-light {
  color: white !important;
  background: #f46666 !important;
}

.slide-fade-enter-active {
  transition: all 0.3s;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
@media (max-width: 576px) {
  .card-container {
    height: calc(100vh - 87px);
    overflow: auto;
    padding: 5px;
    margin: 3px;
    margin-top: 79px;
  }
}
@media (min-width: 577px) {
  .card-container {
    height: calc(100vh - 63px);
    margin-top: 55px;
    overflow: auto;
  }
}
.custom-table .ant-table-thead > tr > th {
  padding: 0px !important;
}
.custom-select .ant-select-selector {
  background-color: #ffffef !important;
}
.inputBgffffef {
  input {
    background-color: #ffffef !important;
  }
  &:hover,
  &:focus {
    input {
      background-color: #ffffef !important;
    }
  }
}
</style>
